import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getTodayAttendance } from "src/redux/api/_hr_attendance.api";
import { AttendanceType } from "src/redux/types/_attendance.type";

interface TodayAttendanceResponse {
  present_today: number;
  absent_today: number;
  half_day_today: number;
  today_attendance: AttendanceType[];
}

export interface AttendanceFilters {
  name?: string;
  status?: string;
  page?: number;
}

export const todayAttendanceKeys = {
  all: ["admin-customers"] as const,
  list: (filters: AttendanceFilters) =>
    [...todayAttendanceKeys.all, "list", filters] as const,
};

export function useTodayAttendance(filters: AttendanceFilters = {}) {
  return useQuery<TodayAttendanceResponse>({
    queryKey: todayAttendanceKeys.list(filters),
    queryFn: () => getTodayAttendance(filters),
    placeholderData: keepPreviousData, // keeps old rows on screen while the next page loads
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
